import { useGetMeQuery } from './authApi';

/**
 * Runs the one request the app can't start without.
 *
 * Two jobs, both invisible:
 *  1. Resolves the session — is there a signed-in account behind the cookie? — which flips
 *     `auth.status` off `unknown` and lets the route guards decide.
 *  2. Primes CSRF. `GET /api/me` goes through the backend's session filter chain, and that chain
 *     is what writes the `XSRF-TOKEN` cookie. Without this call, the very first write a visitor
 *     attempts would have no token to echo back and would be rejected — even a 401 here still
 *     sets the cookie, so an anonymous visitor is covered too.
 */
export function useSessionBootstrap() {
  useGetMeQuery();
}
